import './home.css';
import zini from '../../assets/zini_peace.png';
import logoIcon from '../../assets/icon.png';

function MenuIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M4 7h16M4 12h16M4 17h16" stroke="#6c4ce8" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}


function ChevronRightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M9 5l7 7-7 7" stroke="#6c4ce8" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Home({ onStartMission }) {
  return (
    <div className="home-screen">
      <div className="home-frame">
        <div className="home-topbar">
          {/* <div className="home-logo">
            <img src={logoIcon} alt="" className="home-logo-icon" />
            <span>DealZta</span>
          </div> */}
          {/* <button type="button" className="home-menu-btn" aria-label="Open menu">
            <MenuIcon />
          </button> */}
        </div>

        <div className="home-hero">
          <h1 className="home-title">
            <span className="home-title-line1">Zini&apos;s</span>
            <span className="home-title-line2">Selfie Booth</span>
          </h1>
          <div className="home-badge">
            <span>Take a selfie. Share the fun.</span>
            <span>Unlock a surprise!</span>
          </div>
        </div>

        <div className="home-zini-wrap">
          {/* <div className="home-speech-bubble">Ready to have some fun? 💜</div> */}
          <img src={zini} alt="Zini" className="home-zini-img" />
        </div>

        <button type="button" className="home-cta" onClick={onStartMission}>
          Start Mission
          <span className="home-cta-icon">
            <ChevronRightIcon />
          </span>
        </button>

        <p className="home-footer">Powered By DealZta</p>
      </div>
    </div>
  );
}
